export default {
  computed: {
    userType() {
      return {
        sm: window.isUserSm,
        vimelco: window.isUserVimelco,
        partner: window.isPartner,
        ersaProses: window.isErsaProsesUser,
        endUser: window.isEndUser,
        opi: window.opi
      };
    }
  }
};
